import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { withRouter } from '../../utils/withRouter';
import {
  StyledHeadingContainer,
  StyledFaqContent,
  StyledQuestionText,
  StyledAnswerContent,
  StyledFaqAccordion,
  StyledFaqContact,
  StyledFaqContactInner
} from './Faq.styled';
import { Heading, Button } from '../../mo-gel';
import { ReactComponent as RightArrow } from '../../images/icons/right_icon.svg';

class FaqPage extends Component<any, any> {
  render() {
    const faqItems = [
      {
        question: `What is Breaking the Ice?`,
        content: (
          <StyledAnswerContent>
            Movember Breaking the Ice is a training workshop that uses hockey to teach athletes, parents and coaches how
            to talk about mental health. The program reviews how to recognize mental health issues, what to do and when
            to get help. Athletes learn how to build resilience and overcome challenges in hockey and life.
          </StyledAnswerContent>
        )
      },
      {
        question: `Why is it needed?`,
        content: (
          <StyledAnswerContent>
            The prevalence of mental health problems among adolescents is alarmingly high. With lower rates of accessing
            services than young women, young men and boys represent a group at high risk of developing mental health
            problems. Research has shown that organized sport is an effective and important avenue for supporting mental
            health.
          </StyledAnswerContent>
        )
      },
      {
        question: `When does Breaking the Ice take place?`,
        content: (
          <StyledAnswerContent>
            Movember Breaking the Ice is delivered during regular hockey practice times. (Usually before, during or
            immediately after a regular practice). We come to you and make having mental health conversations easier.
          </StyledAnswerContent>
        )
      }
      // ... other items omitted for brevity (kept the same as before)
    ];

    return (
      <>
        <StyledHeadingContainer>
          <Heading level="h3">Frequently Asked Questions</Heading>
        </StyledHeadingContainer>

        <StyledFaqContent>
          <StyledFaqAccordion
            allowMultipleOpen={true}
            items={faqItems.map((faqItem) => ({
              header: <StyledQuestionText>{faqItem.question}</StyledQuestionText>,
              content: faqItem.content
            }))}
          />
        </StyledFaqContent>

        <StyledFaqContact>
          <StyledFaqContactInner>
            <Heading level="h5" color="white">
              Can't see your question here?
            </Heading>
            <Button primary={true} width="194px" onClick={() => this.props.history.push('/contact')}>
              Contact us
              <RightArrow />
            </Button>
          </StyledFaqContactInner>
        </StyledFaqContact>
      </>
    );
  }
}

const component = withTheme(withRouter(FaqPage));
export { component as FaqPage };
